import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL_EXPENSE = `${config.URL_EXPENSES}/od`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BASE_URL_EXPENSE}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    if (error.response) {
      console.error(`HTTP Error ${error.response.status} in ${method.toUpperCase()} ${url}:`, error.response.data);
      throw new Error(`HTTP ${error.response.status}: ${error.response.data?.message || "Unknown error"}`);
    } else if (error.request) {
      console.error(`Network Error in ${method.toUpperCase()} ${url}: No response received.`);
      throw new Error("Network error: No response from server.");
    } else {
      console.error(`Error in ${method.toUpperCase()} ${url}:`, error.message);
      throw error;
    }
  }
};

// 🔹 Gestión de Políticas (Policies)
export const policy_get = async (fi, ff) => request("get", "/policys", null, { di: fi, df: ff });
export const policy_post = async (data) => request("post", "/policys", data);
export const policy_put = async (id, data) => request("put", `/policys/${id}`, data, { action: "UPDATE" });
export const policy_delete = async (id) => request("delete", `/policys/${id}`);

// 🔹 Detalles de Políticas (Policy Details)
export const policy_details_get = async (id) => request("get", `/policys/${id}/details`);
export const policy_details_post = async (id, data) => request("post", `/policys/${id}/details`, data);
export const policy_details_put = async (id, idd, data) => request("put", `/policys/${id}/details/${idd}`, data);
export const policy_details_delete = async (id, idd) => request("delete", `/policys/${id}/details/${idd}`);
